import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { applicantConfirmDialogProps } from "@/features/applicant/constants/applicantDialogProps";
import type { CoApplicantPaymentModalProps } from "@/features/applicant/types/components";

export function CoApplicantPaymentModal({
  open,
  onClose,
  onPay,
  applicationData,
}: CoApplicantPaymentModalProps) {
  if (!applicationData) return null;

  const feeAmount = applicationData.application_fee || 35.0;

  return (
    <ConfirmDialog
      {...applicantConfirmDialogProps}
      isOpen={open}
      title="Payment Required"
      message={
        `There is a pending Application Fee of $${Number(feeAmount).toFixed(2)} that needs to be paid to proceed with your application.\n\n` +
        "Complete your payment to finalize your application."
      }
      primaryLabel="Pay Now"
      onPrimary={onPay}
      secondaryLabel="Review Application"
      onSecondary={onClose}
      onDismiss={onClose}
      size="wide"
      overlayDataTestId="applicant-modal-co-applicant-payment"
      primaryButtonDataTestId="applicant-modal-co-applicant-payment-pay-btn"
      secondaryButtonDataTestId="applicant-modal-co-applicant-payment-review-btn"
      closeButtonDataTestId="applicant-modal-co-applicant-payment-close-btn"
    />
  );
}
